import { render, staticRenderFns } from "./CompanyCorrPhone.vue?vue&type=template&id=bb55b878&scoped=true&"
import script from "./CompanyCorrPhone.vue?vue&type=script&lang=js&"
export * from "./CompanyCorrPhone.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCorrPhone.vue?vue&type=style&index=0&id=bb55b878&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb55b878",
  null
  
)

export default component.exports